import {
  AWS_REGION,
  COGNITO_AUTH_TYPE,
  COGNITO_USER_POOL,
  COGNITO_USER_POOL_CLIENT,
  COGNITO_USER_POOL_DOMAIN,
  COGNITO_REDIRECT_SIGN_IN,
  COGNITO_REDIRECT_SIGN_OUT
} from '@/constants';
import { AmplifyConfig } from '@/model/cognito';
import { Amplify } from 'aws-amplify';

const AWS_CONFIG: AmplifyConfig = {
  Auth: {
    authenticationFlowType: COGNITO_AUTH_TYPE,
    region: AWS_REGION,
    userPoolId: COGNITO_USER_POOL,
    userPoolWebClientId: COGNITO_USER_POOL_CLIENT
  },
  oauth: {
    domain: COGNITO_USER_POOL_DOMAIN,
    scope: [
      'email',
      'openid',
      'profile',
      'aws.cognito.signin.user.admin'
    ],
    responseType: 'code',
    redirectSignIn: COGNITO_REDIRECT_SIGN_IN,
    redirectSignOut: COGNITO_REDIRECT_SIGN_OUT,
    federationTarget: 'COGNITO_USER_POOLS'
  }
};

export default {
  install: (): any => {
    Amplify.configure(AWS_CONFIG);
  }
};
